/**
 * Any Dealer-specific javascript can be added here.
 *
 * The OEM theme's JS is all bundled by mix, but if you need to include a
 * import a specific file, '@oem-theme' is an alias to the OEM theme's
 * 'assets/js' folder, and can be referenced like so:
 * import { convertStrToMilitaryTime } from '@oem-theme/utilities.js';
 *
 * For convenience, '@dealer' is an alias to this theme's 'assets/js' folder.
 */

import $ from 'jquery';

document.addEventListener('DOMContentLoaded', function () {
  const $header = $('.header');
  const $sentinel = $header.find('.sentinel');

  $sentinel.clone(true, true).prependTo('.site');
  $sentinel.remove();

  const stickyHeader = document.querySelector('.header');
  const sentinal = document.querySelector('.sentinel');

  const handler = (entries) => {
    // entries is an array of observed dom nodes
    // we're only interested in the first one at [0]
    // because that's our .sentinal node.
    // Here observe whether or not that node is in the viewport
    if (!entries[0].isIntersecting) {
      stickyHeader.classList.add('stuck');
    } else {
      stickyHeader.classList.remove('stuck');
    }
  };

  // create the observer
  const observer = new window.IntersectionObserver(handler);
  // give the observer some dom nodes to keep an eye on
  observer.observe(sentinal);

  // re-arrange the home bnp-card
  $('.home .home-bnp').each(function () {
    const $card = $(this);
    const existingToggles = $card.find('.bnp-year-toggles');

    const year = $card.find('.bnp-year').clone(true, true);
    $card.find('.bnp-year').remove();
    year.addClass('dsp-pill-toggle').addClass('is-active').removeClass('bnp-year');
    $card.find('.bnp-cta-title').text('Build & Price');

    const tag = $card.find('.bnp-type-icon').clone(true, true);
    // console.log(`tag: ${model} `, tag);
    $card.find('.bnp-type-icon').remove();

    if (existingToggles.length != 0) {
      // if bnpcard already has toggles - just add the tag
      // console.log(" Hello Already Has Tags ", model);
      existingToggles.append(tag[0]);
    } else {
      // no existing toggles - prepare toggles and then add year, and then tag
      // console.log(" Hello Does Not Already Have Tags ", model);
      const togglesContainer = $('<div></div>');
      togglesContainer.append(year);
      togglesContainer.append(tag);
      togglesContainer.addClass('bnp-year-toggles');
      $card.prepend(togglesContainer);
    }
  });

  $('.section-hours-title, .contacts-title, .section-map-title').each(function () {
    const $title = $(this);
    const $textContainer = $title.find('.icon-round + div');
    $textContainer.addClass('info');
  });

  $('.map-location__title').each(function () {
    const $title = $(this);
    const $phones = $title.find('.js-move-phone');
    const $textContainer = $title.find('.section-map-title .icon-round + div');
    $phones.each(function () {
      const $phone = $(this);
      $phone.clone(true, true).appendTo($textContainer);
      $phone.remove();
    });
  });

  const $customMaps = $('.footer .maps-custom').clone(true, true);

  // replace map area in main nav modal
  const $navModalMaps = $('#modal-header-nav').find('.section-map');
  $navModalMaps.empty();

  // replace map area in map modal
  const $mapModalMaps = $('#modal-header-map').find('.section-map');
  $mapModalMaps.empty();

  $customMaps.appendTo($navModalMaps);
  $customMaps.appendTo($mapModalMaps);

  const $contactPage = $('.page-template-hours');
  if ($contactPage.length != 0) {
    const $contactMapSection = $contactPage.find('#main .contact-map');
    $contactMapSection.empty();
    $contactMapSection.removeClass('rounded-2xl');
    $customMaps.prependTo($contactMapSection);

    // group the address details and their maps together as sets
    const $primaryLocationHours = $contactPage.find('#main .section-hours__primary');
    $primaryLocationHours.appendTo($contactPage.find('#main .map-location.location-1'));

    const $secondaryLocationHours = $contactPage.find('#main .section-hours__secondary');
    $secondaryLocationHours.appendTo($contactPage.find('#main .map-location.location-2'));
  }

  // custom sorting some of the fitlers

  function sortOemMakeFirst() {
    const oemName = 'Ford';
    const $makeFilterElem = $(`#dsp_make`);
    if ($makeFilterElem.length != 0) {
      const placeholderText = $makeFilterElem
        .parents('.filter-container')
        .attr('data-placeholder')
        .trim();

      // original - will store original option/value selected
      const original = $makeFilterElem.val();

      const $options = $makeFilterElem.find('option');

      $options.each(function () {
        const $option = $(this);
        if ($option.attr('data-option-name') == oemName) {
          $option.prependTo($makeFilterElem);
          return;
        }
      });
      $options.each(function () {
        const $option = $(this);
        if ($option.text().trim() == placeholderText) {
          $option.prependTo($makeFilterElem);
          return;
        }
      });

      // will apply original option/value selected
      $makeFilterElem.val(original);
    }
  }

  function sortYearFilter(id) {
    const $filterElem = $(`#${id}`);
    // original - will store original option/value selected
    const original = $filterElem.val();
    let $options = $filterElem.find('option');
    $options.detach().sort(function (a, b) {
      let at = $(a).text();
      let bt = $(b).text();
      return at < bt ? 1 : at > bt ? -1 : 0;
    });
    $options.appendTo($filterElem);
    // will apply original option/value selected
    $filterElem.val(original);
  }

  const $srpPage = $('.page-template-inventory');

  if ($srpPage.length != 0) {
    sortYearFilter('dsp_year_min');
    sortYearFilter('dsp_year_max');
    sortOemMakeFirst();
    try {
      $(document).on('inventory_search_filter_post_update', function () {
        sortYearFilter('dsp_year_min');
        sortYearFilter('dsp_year_max');
        sortOemMakeFirst();
      });
    } catch (err) {
      console.log(err);
    }
  }


});

document.addEventListener("DOMContentLoaded", function () {
  if (!document.body.classList.contains("inventory")) return;

  const el = [...document.querySelectorAll("*")].find(node =>
    node.childNodes.length === 1 &&
    node.childNodes[0].nodeType === 3 &&
    node.textContent.includes("Download Window Sheet")
  );

  if (el) {
    el.textContent = el.textContent.replace("Download Window Sheet", "Download Window Sticker");
  }
});
